import { render, staticRenderFns } from "./StakingERC1155Modal.vue?vue&type=template&id=134685da&scoped=true&"
import script from "./StakingERC1155Modal.vue?vue&type=script&lang=js&"
export * from "./StakingERC1155Modal.vue?vue&type=script&lang=js&"
import style0 from "./StakingERC1155Modal.vue?vue&type=style&index=0&id=134685da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134685da",
  null
  
)

export default component.exports